import isNaN from 'lodash/isNaN'
import toNumber from 'lodash/toNumber'
import React from 'react'
import { FormControl, InputGroup } from 'react-bootstrap'
import { BusyButton } from '@ztechapps/webui.button'
import { ShowIf } from '@ztechapps/webui.util'
import { QuantityWithUom, UomDisplay } from '@ztechapps/product.webui'

export const QuantityInput = ({
  quantity,
  setQuantity,
  isBusy = false,
  canEdit,
  uomSymbol,
}: {
  quantity: number
  setQuantity: (value: number) => void
  isBusy?: boolean
  canEdit?: boolean
  uomSymbol?: string
}) => {
  const increment = React.useCallback(() => {
    //setQuantity((q) => q + 1)
    setQuantity(quantity + 1)
  }, [quantity, setQuantity])

  const decrement = React.useCallback(() => {
    //setQuantity((q) => q - 1)
    setQuantity(quantity - 1)
  }, [quantity, setQuantity])

  const onChange = React.useCallback(
    (e) => {
      const value = toNumber(e?.target?.value)
      if (isNaN(value) || value > 1000) return

      setQuantity(value)
    },
    [setQuantity]
  )

  return (
    <div>
      <InputGroup>
        <ShowIf condition={canEdit}>
          <BusyButton onClick={decrement} disabled={!canEdit || quantity <= 1 || isNaN(quantity) || isBusy}>
            −
          </BusyButton>
        </ShowIf>
        <ShowIf condition={canEdit}>
          <FormControl value={quantity} onChange={onChange} disabled={true} />
        </ShowIf>
        <ShowIf condition={!canEdit}>
          <h5>
            <strong>
              <QuantityWithUom quantity={quantity} symbol={uomSymbol} />
            </strong>
          </h5>
        </ShowIf>
        <ShowIf condition={canEdit}>
          <BusyButton onClick={increment} disabled={!canEdit || isNaN(quantity) || isBusy}>
            +
          </BusyButton>
        </ShowIf>
        <ShowIf condition={canEdit && !!uomSymbol}>
          <InputGroup.Text className="px-1">
            <UomDisplay>{uomSymbol}</UomDisplay>
          </InputGroup.Text>
        </ShowIf>
      </InputGroup>
    </div>
  )
}
